import { EntityWarningContent } from '@internal/backstage-plugin-devops-react';
import { RuleOverview } from '../EntityPages';

export const RuleOverviewTab = () => {
  return (
    <>
      <EntityWarningContent />
      <RuleOverview />
    </>
  );
};
